import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import { Reveal } from "@/components/motion";
import { sectors } from "@/data/sectors";
import { serviceBySlug } from "@/data/services";
import { usePageMeta } from "@/lib/api";

export default function SolutionsPage() {
  usePageMeta(
    "ESG & Sustainability Solutions by Industry | SarvaRitam — Financial Services, Manufacturing, Energy",
    "Sector-specific ESG solutions for financial services, real estate and infrastructure, manufacturing, energy, and consumer and technology companies."
  );
  return (
    <>
      <PageHero
        eyebrow="Solutions"
        title={[<>ESG across <span className="text-gold">industries.</span></>]}
        intro="Different industries carry different exposures, data challenges and stakeholder expectations. We shape the approach to match."
      />
      <section className="bg-ink text-white sec border-t rule-dark">
        <div className="wrap space-y-5">
          {sectors.map((s, i) => (
            <Reveal key={s.slug} delay={0.04 * i}>
              <article id={s.slug} className="border rule-dark p-8 sm:p-12 scroll-mt-24 hover:border-gold/40 transition-colors duration-300" data-testid={`industry-section-${s.slug}`}>
                <div className="grid lg:grid-cols-12 gap-8">
                  <div className="lg:col-span-5">
                    <span className="font-mono text-[11px] text-gold">{String(i + 1).padStart(2, "0")}</span>
                    <h2 className="h-display font-bold text-2xl sm:text-4xl mt-3 leading-tight">{s.name}</h2>
                  </div>
                  <div className="lg:col-span-7">
                    <p className="text-mute text-[15px] leading-relaxed">{s.desc}</p>
                    <p className="eyebrow text-white/68 mt-8 mb-4">Relevant services</p>
                    <div className="flex flex-wrap gap-x-6 gap-y-2.5">
                      {s.services.map((slug) => {
                        const svc = serviceBySlug(slug);
                        return svc ? (
                          <Link key={slug} to={`/services/${slug}`} className="u-sweep text-[13.5px] font-semibold text-white hover:text-gold transition-colors" data-testid={`industry-service-${slug}`}>
                            {svc.name}
                          </Link>
                        ) : null;
                      })}
                    </div>
                    <Link to={`/contact?industry=${encodeURIComponent(s.name)}`} className="btn-outline-gold mt-9" data-testid={`industry-cta-${s.slug}`}>
                      Discuss ESG for {s.name.split(" &")[0]} <ArrowUpRight size={14} />
                    </Link>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
